export const getIsCarregandoRelatorioAuditoria =
(state) => state.relatoriosAuditoria.isCarregandoRelatorioAuditoria

export const getIsCarregandoRelatorioSumario =
  (state) => state.relatoriosAuditoria.isCarregandoRelatorioSumario
